import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Endpoint } from '@app/constants/endpoints.constants';
import { UserTimesheet } from '@app/timesheet-user/models/user-timesheet.interface';
import { Observable } from 'rxjs';
import { TimesheetRow } from '@app/timesheet-user/models/timesheet-row.interface';
import { TimesheetStatus } from '@app/shared/constants/timesheet.constants';
import { ExportType } from '@app/shared/components/export-box/export-box.constants';

@Injectable({
  providedIn: 'root'
})
export class TimesheetRepoService {
  constructor(private _httpClient: HttpClient) {}

  loadTimesheet(year: number, month: number): Observable<UserTimesheet> {
    return this._httpClient.get<UserTimesheet>(Endpoint.Timesheets, { params: { year: `${year}`, month: `${month}` } });
  }

  loadUserTimesheet(username: string, year: number, month: number): Observable<UserTimesheet> {
    return this._httpClient.get<UserTimesheet>(Endpoint.Timesheets, {
      params: { username, year: `${year}`, month: `${month}` }
    });
  }

  updateTimesheet(timesheetId: number, rowId: number, changedValues: TimesheetRow): Observable<TimesheetRow> {
    return this._httpClient.patch<TimesheetRow>(`${Endpoint.Timesheets}`, changedValues, {
      params: { timesheetId: `${timesheetId}`, rowId: `${rowId}` }
    });
  }

  submitTimesheetStatus(year: number, month: number): Observable<undefined> {
    return this._httpClient.patch<undefined>(
      `${Endpoint.Timesheets}${Endpoint.Submit}`,
      {},
      {
        params: { year: `${year}`, month: `${month}` }
      }
    );
  }

  reopenTimesheet(timesheetId: number): Observable<undefined> {
    return this._httpClient.patch<undefined>(`${Endpoint.Timesheets}/${timesheetId}${Endpoint.Reopen}`, {});
  }

  updateTimesheetData(timesheet: UserTimesheet): Observable<UserTimesheet> {
    return this._httpClient.post<UserTimesheet>(`${Endpoint.Timesheets}`, timesheet);
  }

  recallTimesheet(timesheetId: number): Observable<TimesheetStatus> {
    return this._httpClient.patch<TimesheetStatus>(`${Endpoint.Timesheets}/${timesheetId}${Endpoint.Recall}`, {});
  }

  exportTimesheet(
    username: string,
    year: number,
    month: number,
    filename: string,
    format: ExportType
  ): Observable<HttpResponse<Blob>> {
    return this._httpClient.get<Blob>(Endpoint.ExportTimesheet, {
      params: { username, year: year.toString(), month: month.toString(), filename, format },
      observe: 'response',
      responseType: 'blob' as 'json'
    });
  }
}
